import type { IMultiLanguageText } from "@/data/model/Shared";

import { useIdentityStore } from "@/data/stores/identity";
import { translate, translateByLocationLanguage } from "@/shared/localization/language";

interface IInternalNameItem {
    name?: IMultiLanguageText;
    internalName?: string;
}

export function getNameInLocationLanguage(item: IInternalNameItem, useInternalName: boolean): string {
    return useInternalName ? getArticleNameWithInternalName(item) : translateByLocationLanguage(item.name);
}

// the Mobile POS (operators: waiters and admins) follows the rule of the internal frontends, everybody else
// (end users, anonymous users) gets the name in their own language - not the location language
export function getNameForCurrentUser(item: IInternalNameItem): string {
    return useIdentityStore().hasOperatorAccess
        ? getNameInLocationLanguage(item, true)
        : translate(item.name);
}

// internal frontends: the internal name, else the name in the location language, else the first
// filled one of EN > DE > FR > IT. a blank internal name counts as not filled
function getArticleNameWithInternalName(item: IInternalNameItem): string {
    if (item.internalName != null && item.internalName.trim() !== "") {
        return item.internalName;
    }
    return translateByLocationLanguage(item.name);
}
